import placeholder from '../assets/images/placeholder.jpeg';
import { IMG_URL } from '../configs/app-global';

/**
 * Resolve image URL from API response (string, object with path/url/name, or array).
 * Full URLs (http/https) are returned as-is; relative paths get IMG_URL prepended.
 */
function resolveImageUrl(url) {
  if (url == null) return '';
  if (typeof url === 'string') return url;
  if (Array.isArray(url)) return resolveImageUrl(url[0]);
  if (typeof url === 'object') {
    const u = url.path ?? url.url ?? url.name ?? url.title ?? '';
    return typeof u === 'string' ? u : resolveImageUrl(u);
  }
  return '';
}

export default function getImage(url) {
  const resolved = resolveImageUrl(url);
  if (!resolved) return placeholder;
  if (resolved.startsWith('http://') || resolved.startsWith('https://')) return resolved;
  return IMG_URL ? IMG_URL + resolved : resolved;
}
